module.exports = __webpack_public_path__ + "img/A002_R_home slider.e574150b.jpg";